import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  return (
""
  );
};

export default FAQs;
